// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CheckoutPoNumber } from "@guestsupply/App/Handlers/XNG/CheckoutPoNumber";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";

export type CheckoutPoNumberState = Readonly<{
    poNumber: string;
}>;

const initialState: CheckoutPoNumberState = {
    poNumber: "",
};
const reducer = {
    "xCheckoutPoNumber/SetPoNumber": (draft: Draft<CheckoutPoNumberState>, action: { data: CheckoutPoNumber }) => {
        draft.poNumber = action.data.poNumber;
    },
};

const xCheckoutPoNumber = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xCheckoutPoNumber = xCheckoutPoNumber;

export type xCheckoutPoNumberState = {
    xCheckoutPoNumber: CheckoutPoNumberState;
} & ApplicationState;

type CheckoutPoNumberReducers = {
    poNumber: typeof xCheckoutPoNumber;
};

export type xCheckoutPoNumber = Parameters<CheckoutPoNumberReducers[keyof CheckoutPoNumberReducers]>[1] | AnyAction;
